module.exports = __webpack_public_path__ + "img/bg-trailer.8bf0d185.jpg";